// Mock dati per pannello "Mezzi Disponibili Live".
// Shape: array di sedi → array di mezzi.
// `turni`: array di fasce orarie occupate [oraInizio, oraFine] su 24h (es. [[6,14]]).
// Usato per colorare i 24 blocchetti orari della timeline (12 passate + 12 future).
// Sostituire con chiamata API quando backend pronto (vedi plan).
export const SEDI_MEZZI_MOCK = [
    {
        sede: "Mercatale",
        mezzi: [
            { targa: "AB123CD", tipologia: "Furgone 35Q",   stato: "disponibile", motivo: null, turni: [] },
            { targa: "EF456GH", tipologia: "Spazzatrice",   stato: "fermo",       motivo: "Manutenzione in corso — Interacta #1234", turni: [[0, 24]] },
            { targa: "IJ789KL", tipologia: "Pianale 35Q",   stato: "in_turno",    motivo: "Turno 06:00–14:00 — Operatore M. Rossi", turni: [[6, 14]] },
            { targa: "QR345ST", tipologia: "Furgone Attr.", stato: "disponibile", motivo: null, turni: [[22, 24]] },
            { targa: "BT901UV", tipologia: "Furgone 35Q",   stato: "disponibile", motivo: null, turni: [] },
            { targa: "CG234WX", tipologia: "Pianale 35Q",   stato: "disponibile", motivo: null, turni: [[18, 22]] },
            { targa: "DH567YZ", tipologia: "Spazzatrice",   stato: "in_turno",    motivo: "Turno 14:00–22:00 — Operatore A. Neri", turni: [[14, 22]] },
            { targa: "EJ890AB", tipologia: "Compattatore",  stato: "disponibile", motivo: null, turni: [[0, 6]] },
            { targa: "FK123CD", tipologia: "Furgone 35Q",   stato: "disponibile", motivo: null, turni: [] },
            { targa: "GL456EF", tipologia: "Pianale 35Q",   stato: "fermo",       motivo: "Revisione obbligatoria scaduta", turni: [[0, 24]] },
            { targa: "HM789GH", tipologia: "Furgone Attr.", stato: "disponibile", motivo: null, turni: [[6, 10]] },
        ],
    },
    {
        sede: "Sasso Marconi",
        mezzi: [
            { targa: "UV678WX", tipologia: "Pianale 35Q",   stato: "disponibile", motivo: null, turni: [] },
            { targa: "YZ901AB", tipologia: "Spazzatrice",   stato: "disponibile", motivo: null, turni: [[4, 8]] },
            { targa: "CD234EF", tipologia: "Compattatore",  stato: "fermo",       motivo: "Segnalazione guasto trasmissione — Interacta #1240", turni: [[0, 24]] },
        ],
    },
    {
        sede: "Casalecchio",
        mezzi: [
            { targa: "GH567IJ", tipologia: "Furgone 35Q",   stato: "in_turno",    motivo: "Turno 06:00–14:00 — Operatore L. Bianchi", turni: [[6, 14]] },
            { targa: "KL890MN", tipologia: "Furgone 35Q",   stato: "in_turno",    motivo: "Turno 14:00–22:00 — Operatore G. Verdi", turni: [[14, 22]] },
            { targa: "OP123QR", tipologia: "Pianale 35Q",   stato: "disponibile", motivo: null, turni: [[20, 24]] },
        ],
    },
    {
        sede: "Borgonuovo",
        mezzi: [
            { targa: "WX789YZ", tipologia: "Furgone Attr.", stato: "disponibile", motivo: null, turni: [[2, 6]] },
            { targa: "AC012BD", tipologia: "Spazzatrice",   stato: "disponibile", motivo: null, turni: [] },
        ],
    },
];

// Metadati stato → colore/icona/label, usati sia per badge che per legenda.
export const STATO_META = {
    disponibile: { label: "Disponibile", color: "#10B981", bg: "#D1FAE5", icon: "✓" },
    fermo:       { label: "Fermo",       color: "#DC2626", bg: "#FEE2E2", icon: "⚠" },
    in_turno:    { label: "In turno",    color: "#D97706", bg: "#FEF3C7", icon: "⏱" },
    fuori_sede:  { label: "Fuori sede",  color: "#6B7280", bg: "#E5E7EB", icon: "↗" },
};
